import { useUser } from '@cobliteam/hooks';

import { SpeedCarIcon } from '@cobliteam/base-components';

import { Button, InfoBanner, Typography } from '@cobliteam/ui/components';

import {
  isFleetInMedianSpeedPartialReleaseBatch,
  medianSpeedFullReleaseDate,
} from '../../utils/utils';

const MedianSpeedBanner = ({
  bannerPage,
  onExplanationModal = false,
}: {
  bannerPage: 'eventos' | 'alertas';
  onExplanationModal?: boolean;
}) => {
  const { getSession } = useUser();
  const session = getSession();

  const shouldHideBanner = isFleetInMedianSpeedPartialReleaseBatch(session);

  if (shouldHideBanner) {
    return null;
  }

  const isMedianReleased =
    new Date().getTime() >= medianSpeedFullReleaseDate.getTime();

  const pageBannerText = isMedianReleased
    ? `Desde o dia 01/03/24, os ${bannerPage} de velocidade exibem a velocidade média atingida durante o evento. Essa nova métrica considera todas as velocidades atingidas, fornecendo mais contexto sobre o ocorrido. A gravidade do evento também passou a ser calculada a partir da velocidade média. Saiba mais na central de ajuda.`
    : `A partir do dia 01/03/24, os ${bannerPage} de velocidade exibirão a velocidade média atingida durante o evento. Essa nova métrica considera todas as velocidades atingidas, fornecendo mais contexto sobre o ocorrido. A gravidade do evento também será calculada a partir da velocidade média. Saiba mais na central de ajuda.`;

  const explanationModalBannerText = isMedianReleased
    ? `Desde o dia 01/03/24, os ${bannerPage} de velocidade são baseados na média das velocidades medidas durante o evento.`
    : `A partir do dia 01/03/24, os ${bannerPage} de velocidade serão baseados na média das velocidades medidas durante o evento.`;

  const handleClick = () => {
    window.open(
      'https://suporte.cobli.co/o-que-%C3%A9-a-velocidade-m%C3%A9dia-de-um-evento',
      '_blank'
    );
  };

  return (
    <InfoBanner size="default">
      <InfoBanner.Content>
        <InfoBanner.Icon icon={<SpeedCarIcon />} />
        <InfoBanner.Text>
          <Typography variant="caption-bold" color="secondary">
            {onExplanationModal ? explanationModalBannerText : pageBannerText}
          </Typography>
        </InfoBanner.Text>
      </InfoBanner.Content>

      {!onExplanationModal && (
        <InfoBanner.Actions>
          <Button variant="link" onClick={handleClick}>
            Central de ajuda
          </Button>
        </InfoBanner.Actions>
      )}
    </InfoBanner>
  );
};

export default MedianSpeedBanner;
